function formatarCPF(cpf) {
  cpf = cpf?.replace(/\D/g, '');
  cpf = cpf?.slice(0, 11);
  cpf = cpf?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');

  return cpf;
}
export default formatarCPF
